const CopilotOverlay = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center z-50 opacity-100 border-brand-primary">
      <div className="bg-card p-6 rounded-lg shadow-lg text-center border border-border">
        <h3 className="text-xl font-semibold mb-2 text-foreground">Drop Files Here</h3>
        <p className="text-muted-foreground">
          Release to upload your files (max 3 files)
        </p>
        <p className="text-sm text-muted-foreground mt-2">
          Accepted file types: PDF, Excel, JPG, PNG, DOC
        </p>
      </div>
    </div>
  );
};

export default CopilotOverlay;
